export default __webpack_public_path__ + "static/media/benoit gremaud.48cbec91.jpg";